import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faPowerOff, faUser, faTrash, faPencilAlt, faWindowClose, faExclamationTriangle, faPlus, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(faLink);
  library.add(faUser);
  library.add(faPowerOff);
  library.add(faTrash);
  library.add(faPencilAlt);
  library.add(faWindowClose);
  library.add(faExclamationTriangle);
  library.add(faPlus);
  library.add(faSearch);
  library.add(faTimes);
}

export default initFontAwesome;
